<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import CookieBanner from '@/components/CookieBanner.vue';
import UpdateToast from '@/components/UpdateToast.vue';

const auth = useAuthStore();

onMounted(() => {
  void auth.bootstrap();
});
</script>

<template>
  <RouterView v-if="auth.bootstrapped" />
  <div v-else class="boot-shell">
    <div class="boot-spinner" aria-label="Cargando" />
  </div>
  <CookieBanner />
  <!-- D77: aviso de versión nueva (fallback si el usuario no navega) -->
  <UpdateToast />
</template>

<style scoped>
.boot-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-page, #f7f8fa);
}
.boot-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(6, 64, 121, 0.15);
  border-top-color: var(--sky-700, #0f6cb8);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
